/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useSelector, useDispatch } from 'react-redux';
import { useError } from 'services/ErrorContext';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { fetchParametros } from 'utils/redux/features/parametrosSlice';
import PageContainer from 'components/PageContainer/PageContainer';
import FormParametros from './FormParametros';
import { cambiarParametroPorId } from 'services/servicioPut';
import { Box } from '@mui/material';
import { anchoMaxLogueado } from 'utils/constants';

const Cuotas = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [mensajeExito, setMensajeExito] = useState('');
  const { parametros, loadingParametros, errorParametros } = useSelector((state: RootState) => state.parametros);
  const { error, setError, clearError, loading, setLoading } = useError();
  const cuotas = parametros.filter(p => p.Nombre.includes('Cuota'));
  const error401 = errorParametros?.includes('permisos');

  useEffect(() => {
    dispatch(fetchParametros());
  }, [dispatch]);

  async function handleSubmit(data: any): Promise<void> {
    clearError();

    const requestEdicionParametro = {
      Id: data.Id,
      Nombre: data.Nombre,
      Valor: data.Valor,
    };

    try {
      await cambiarParametroPorId(requestEdicionParametro, setError, setLoading);
      setMensajeExito('¡Cuota modificada con éxito!');
    } catch (error) {
      console.error('Error de edición:', error);
    }
  }

  const handleVolver = () => {
    setMensajeExito('');
  };

  return (
    <PageContainer>
      {loadingParametros ? (
        <Spinner />
      ) : errorParametros ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Box maxWidth={anchoMaxLogueado} mx="auto">
          <FormParametros
            parametros={cuotas}
            onSubmit={handleSubmit}
            tipo="cuota"
            loading={loading}
            mensajeExito={mensajeExito}
            mensajeError={error}
            onVolver={handleVolver}
          />
        </Box>
      )}
    </PageContainer>
  );
};

export default Cuotas;
